import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import NotificationsHistoricList from 'notifications_historic/components/list';

const NotificationsHistoricListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  subcompany = {},
  handleToggle = () => {}, ///////
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  columnSearch,
  handleToggleSearch = () => {}, // Agregar
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      {/* <NotificationsHistoricList.Header
        companyId={company.id}
        subcompanyId={subcompany.id}
      // canAdd={permissions["acl.users.add"]} // acl.notification_historic.add
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={t('notification_historic.title')}
          icon={'archive'}
          button={
            <NotificationsHistoricList.Filters
              handleSubmit={handleSubmit}
              handleToggleSearch={handleToggleSearch} // Agregar
              columnSearch={columnSearch} // Agregar
              handleValueChange={handleFiltersChange}
              values={filters}
            />
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <NotificationsHistoricList.Table
              company={company} ////////
              subcompany={subcompany} ///////////
              permissions={permissions} ///////
              handleToggle={handleToggle} //////////
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </NotificationsHistoricList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(NotificationsHistoricListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/NotificationsHistoricListView.js